/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Scroll direction options
 */
export const scrollOptions = {
  default: {
    direction: 'vertical',
    throttle: 200,
  },
};
